import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-zinc-900">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, tone = "default", onClick, testId }) {
  const tones = {
    default: "border-border",
    blue: "border-cc-blue/30",
    green: "border-cc-green/40",
    orange: "border-cc-orange/40",
    red: "border-red-300",
  };
  const iconTone = {
    default: "text-zinc-400", blue: "text-cc-blue", green: "text-cc-green", orange: "text-cc-orange", red: "text-red-500",
  };
  const urgent = tone === "red" && value > 0;
  return (
    <div onClick={onClick} data-testid={testId}
      className={cn("bg-white border rounded-md p-5 transition-all hover:shadow-sm", tones[tone], onClick && "cursor-pointer", urgent && "cc-urgent")}>
      <div className="flex items-start justify-between">
        <span className="text-xs uppercase tracking-[0.12em] text-zinc-400 font-semibold">{label}</span>
        {Icon && <Icon className={cn("w-5 h-5", iconTone[tone])} strokeWidth={2} />}
      </div>
      <div className={cn("mt-3 text-3xl font-semibold font-mono", urgent ? "text-red-600" : "text-zinc-900")}>{value ?? 0}</div>
    </div>
  );
}

export function Card({ title, children, className, action, ...rest }) {
  return (
    <div className={cn("bg-white border border-border rounded-md", className)} {...rest}>
      {(title || action) && (
        <div className="flex items-center justify-between px-5 py-3 border-b border-border">
          <h3 className="font-medium text-zinc-800">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}

export function EmptyState({ text }) {
  return <div className="text-center text-sm text-zinc-400 py-10">{text}</div>;
}

export function Field({ label, children }) {
  return (
    <div className="space-y-1.5">
      <label className="text-xs uppercase tracking-[0.1em] text-zinc-400 font-semibold">{label}</label>
      {children}
    </div>
  );
}
